import React from "react"
import { useTranslation } from "react-i18next"
import ModalPortal from "../../../../components/Modal/ModalPortal"
import defaultStyle from "../../../../styles/defaultPageStyle.module.css"
import InputField from "../../../../components/InputField/InputField"
import Button, { ButtonIcon } from "../../../../components/Button/Button"
import { faClose, faPrint } from "@fortawesome/free-solid-svg-icons"
import { TitlePageResponsiveIconSmall } from "../../../../components/Titles/Titles"
import THEME from "../../../../configuration/Theme"
import { SIZE } from "../../../../configuration/Sizes"
import Animate, { AnimationTypes } from "../../../../components/Animate/Animate"

type AddPrintAgentPupopProps = {
  isOpen: boolean
  agentName: string
  onClose: () => void
  onChangeAgentName: (value: string) => void
  onGeneratePairing: () => void
}

export const AddPrintAgentPupop: React.FC<AddPrintAgentPupopProps> = ({
  isOpen,
  agentName,
  onClose,
  onChangeAgentName,
  onGeneratePairing,
}) => {
  const { t } = useTranslation(["pages"])

  if (!isOpen) {
    return null
  }

  return (
    <ModalPortal>
      <div className={defaultStyle.overlay}>
        <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
          <div className={defaultStyle.alert1}>
            <TitlePageResponsiveIconSmall
              iconColor={THEME.colors.iconBGColor}
              title={t("label_print_automation_add_agent")}
              icon={faPrint}
              subtitleChildren={
                <ButtonIcon
                  sizeNumber={SIZE.buttonCloseIconSize}
                  bgColor={THEME.colors.buttonBGCloseColor}
                  iconColor={THEME.colors.buttonFGCloseColor}
                  icon={faClose}
                  onClick={onClose}
                  size="small"
                  descriptionKey="interactionDescriptions:pages.myRestaurant.printAutomation.components.addPrintAgentPupop.button.onClose"
                />
              }
            />

            <div className="mt-4 grid gap-3">
              <InputField
                type="text"
                value={agentName}
                onChange={(event) => onChangeAgentName(event.target.value)}
                placeholder={t("label_print_automation_agent_name")}
                descriptionKey="interactionDescriptions:pages.myRestaurant.printAutomation.components.addPrintAgentPupop.input.printAutomationAgentName"
              />

              <Button
                bgColor={THEME.colors.buttonBGSaveColor}
                label={t("label_print_automation_generate_pairing")}
                onClick={onGeneratePairing}
                descriptionKey="interactionDescriptions:pages.myRestaurant.printAutomation.components.addPrintAgentPupop.button.printAutomationGeneratePairing"
              />
            </div>
          </div>
        </Animate>
      </div>
    </ModalPortal>
  )
}
